<template>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div>
            <div style="padding: 10px 20px;border: 1px solid rgb(238, 238, 238);background: white;" >
                <h4 class="sub-title">Bank Transfer Detail <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" v-if="!isEdit" @click="isEdit = true;"><span class="glyphicon glyphicon-pencil"></span> Edit</a></h4>
                <hr>
                <div class="row" style="margin-bottom: 15px;">
                    <div class="col-sm-3">
                        <label for="bankTransferInfoPhoto">Bank Transfer Info Photo</label>
                    </div>
                    <div class="col-sm-6" v-if="banktransferinfo_photo">
                        <div v-if="isEdit">
                            <uploadfile v-model="banktransferinfo_photo.contentvalue" :height="250" @onUploaded="onUploaded"></uploadfile>   
                        </div>
                        <div v-else style=" overflow-y: hidden; border: 1px solid #eee">
                            <template v-if="banktransferinfo_photo.contentvalue">
                                <img :src="banktransferinfo_photo.contentvalue" alt="" class="img-responsive">
                            </template>
                            <template v-else>
                                <img src="/static/img/assets/generic/generic_default_thumbnail.png" class="img-responsive">
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-sm-3" >
                        <label for="bankTransferInfo">Bank Transfer Info</label>
                    </div>
                    <div class="col-sm-6" v-if="banktransferinfo">
                        <template v-if="isEdit">
                            <textarea class="form-control mb-2" style="resize: vertical;margin-bottom:5px" rows="3" v-model="banktransferinfo.contentvalue"></textarea>
                        </template>
                        <template v-else>
                            {{banktransferinfo.contentvalue}}
                        </template>
                    </div>
                </div>

                <div class="text-center" style="margin-bottom: 25px;">
                    <template v-if="isEdit">
                        <a href="javascript:void(0);" class="btn btn-default" @click="reset">Cancel</a>
                        <a href="javascript:void(0);" class="btn btn-primary" @click="saveContent">Save</a>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from 'axios'
import api from '@/api'
import config from '@/config'
import uploadfile from '@/components/elements/uploadfile'

export default {
    props: ['init'],
    data: function(){
        return {
            isEdit: false, 

            normal_charge: undefined,
            ems_charge: undefined,
            additionalproduct_charge: undefined,
            banktransferinfo_photo: undefined,
            banktransferinfo: undefined,
        }
    },
    components: {
        uploadfile
    },
    created() {
        var vm = this
    },
    created: function(){
        this.banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo);
        this.banktransferinfo = Object.assign({}, this.init.banktransferinfo);
        
        //cache
        this.cached_banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo);
        this.cached_banktransferinfo = Object.assign({}, this.init.banktransferinfo);
    },
    methods: {
        reset: function(){
            var vm = this
            this.banktransferinfo_photo = Object.assign({}, this.cached_banktransferinfo_photo);
            this.banktransferinfo = Object.assign({}, this.cached_banktransferinfo);
            vm.isEdit = false

            vm.$emit('reset')
        },
        saveContent: function(){
            var vm = this
            vm.sendRequest(this.banktransferinfo_photo)
            vm.sendRequest(this.banktransferinfo)
            this.cached_banktransferinfo_photo = Object.assign({}, this.banktransferinfo_photo);
            this.cached_banktransferinfo = Object.assign({}, this.banktransferinfo);
            vm.isEdit = false
        },
        onUploaded: function(image){
            this.banktransferinfo_photo.contentvalue = image
        },
        sendRequest: function(content,callback){
            var vm = this
            api.updateConfig(content,function(error,response){
                if (error) {
                    console.error(error)
                    return
                }
            })
        }
    },
    watch: {
        init: function(){
            this.banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo);
        
            //cache
            this.cached_banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo);
        }
    }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/TransferPayment.vue